// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__kmONs","buttons":"PendingPaymentAlert_buttons__2LexN"};